var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessagesNavIcon = function SvgMessagesNavIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD15D",
    d: "M0 6c0-1.1.9-2 2-2h18a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AA2C4",
    d: "M15 11a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C2E89",
    d: "M9 11a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA3556",
    d: "M3 11a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD15D",
    d: "m3.77 20.92 5.75-3.6c.43-.26.24-.92-.26-.92H3.5a.5.5 0 0 0-.5.5v3.6c0 .4.43.63.77.42"
  })));
};
export default SvgMessagesNavIcon;